// Vendors
import $ from 'jquery';
import { AJAX_URL } from '../config';
import modals from '../framework/modal';

// Init modals
modals('[data-modal]');

const signUpModal = $('[data-modal="modal-sign-up-and-save"]');
const HIDE_MODAL_KEY = 'hide-signup-modal';
const HIDE_MODAL_DAYS = 30;
const MODAL_ENABLED = false;
let modalTimeout = false;
let scrollLimit = false;
let alreadyShown = false;

const isLoggedIn = () => document.body.classList.contains('logged-in');

const isModalSuppressed = () => {
  const stored = localStorage.getItem(HIDE_MODAL_KEY);
  if (!stored) return false;
  const daysSinceDismissed = (Date.now() - parseInt(stored, 10)) / (1000 * 60 * 60 * 24);
  return daysSinceDismissed < HIDE_MODAL_DAYS;
};

$(document).ready(function () {
  if (MODAL_ENABLED && !isLoggedIn() && !isModalSuppressed()) {
    startModalTimer();
    startTrackingScroll();
  }
});

// Save Cookie Once Modal Hides
signUpModal.on('modal:afterHide', (event) => {
  saveHideModalCookie();
});

const maybeShowModal = () => {
  if (!alreadyShown && (modalTimeout || scrollLimit)) {
    alreadyShown = true;
    showSignUpModal();
  }
};

const showSignUpModal = () => signUpModal.trigger('modal:show');

const hideSignUpModal = () => signUpModal.trigger('modal:hide');

const saveHideModalCookie = () => localStorage.setItem(HIDE_MODAL_KEY, Date.now());

const startModalTimer = () =>
  setTimeout(() => {
    modalTimeout = true;
    maybeShowModal();
  }, 15000);

const startTrackingScroll = () =>
  window.addEventListener('scroll', checkPageScrolledAmount, false);

//Get the scroll page percentage
const getScrollHeight = () => {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
};

const checkPageScrolledAmount = () => {
  const docHeight = getScrollHeight();
  const percentageScrolledToShow = 25;
  let winheight =
    window.innerHeight ||
    (document.documentElement || document.body).clientHeight;
  let scrollTop =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollTop;
  let trackLength = docHeight - winheight;
  let pageScrolled = Math.floor((scrollTop / trackLength) * 100); // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)

  if (pageScrolled === percentageScrolledToShow && !scrollLimit) {
    scrollLimit = true;
    maybeShowModal();
  }
};

// Handle Form Submission
$('form#sign-up-and-save').on('submit', (event) => {
  event.preventDefault();
  const $userEmailInputField = $("input[name='signup-email']");
  const $userNotice = $('.notice');
  const userEmail = $userEmailInputField.val();

  if (!userEmail) return;

  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}wl_subscribe_user`,
    dataType: 'json',
    encode: true,
    data: { email: userEmail },
    success: (res) => {
      $userNotice.html(res.data.message);
      $userNotice.removeClass('u--display-none');

      if (res.success) {
        $userNotice.addClass('notice--green');
        setTimeout(() => {
          saveHideModalCookie();
          hideSignUpModal();
          localStorage.setItem('apply-signup-and-save-discount', 1);
          window.location.replace('/cart');
        }, 5000);
      } else {
        $userNotice.addClass('notice--red');
      }
    }
  });
});
